<template>
  <!-- eslint-disable -->
<v-container fluid>
<v-slide-y-transition mode="out-in">
  <div>
    <v-speed-dial v-model="fab" right top fixed direction="bottom" transition="slide-y-reverse-transition">
      <template v-slot:activator>
        <v-btn class="refresh-btn" v-model="fab" color="blue darken-2" dark fab>
          <v-icon v-if="fab">close</v-icon>
          <v-icon v-else>ac_unit</v-icon>
        </v-btn>
      </template>
      <v-btn class="refresh-calamities-btn" fab dark small color="red" @click="loadCalamities()">
        <v-icon>refresh</v-icon>
      </v-btn>
      <v-btn class="calamities-call-btn" fab dark small color="red" @click="openCalamityCallsDialog()">
        <v-icon>perm_phone_msg</v-icon>
      </v-btn>
    </v-speed-dial>
    <v-data-table :mobile-breakpoint="0" class="calamity-data-table no-wrap-th" disable-pagination hide-default-footer :items="calamities" item-key="Id" :headers="headers" :loading="loading">
      <template v-slot:item="{ item }">
        <tr class="calamity-row">
          <td>{{item.Id}}</td>
          <td>{{ item.Date | formatWholeDate }}</td>
          <td>{{ item.Title }}</td>
          <td>{{ item.Client }}</td>
          <td>{{ item.Location }}</td>
          <td class="client-email">
            <span text v-if="item.ClientNotificationSent">
              <v-icon style="padding-left: 6px; justify-content: unset; width: 50px;" color="green" >check_box_outline</v-icon>
            </span>
            <v-btn icon v-on:click="sendClientEmail(item.Id)" text v-else>
              <v-icon color="red">check_box_outline_blank</v-icon>
            </v-btn>
          </td>
          <td class="carrier-request">
            <span text v-if="item.CarrierRequestSent">
              <v-icon style="padding-left: 6px; justify-content: unset; width: 50px;" color="green">check_box_outline</v-icon>
            </span>
            <v-btn icon class="carrier-request-btn" v-on:click="sendRequest(item.Id)" text v-else>
              <v-icon color="red">check_box_outline_blank</v-icon>
            </v-btn>
          </td>
          <!--<td>
            <span text v-if="item.NotificationCallsSent">
              <v-icon style="padding-left: 6px; justify-content: unset; width: 50px;" color="green">check_box_outline</v-icon>
            </span>
            <v-btn icon v-on:click="openCalamityCallsDialog()" v-else>
              <v-icon color="red">check_box_outline_blank</v-icon>
            </v-btn>
          </td> -->
          <td>
            <v-row class="transit-state-data" style="flex-wrap: nowrap; margin: 0;">
              <v-tooltip bottom v-for="transit in TransitProperties" :key="transit.key">
                <template v-slot:activator="{ on }">
                  <v-chip style="margin: 0 3px;" label :class="transit.class" v-on="on">{{item[transit.key]}}</v-chip>
                </template>
                <span>{{transit.name}}</span>
              </v-tooltip>
            </v-row>
          </td>
          <td>{{item.PackageCount}}</td>
          <td>
            <v-row style="flex-wrap: nowrap;">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" class="client-email-btn" icon v-on:click="sendClientEmail(item.Id)">
                    <v-icon>email</v-icon>
                  </v-btn>
                </template>
                <span>Send an email update to the client</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" class="edit-email-dialog-btn" icon v-on:click="editClientEmail(item.Id, item.NotificationRecipients)">
                    <v-icon>edit</v-icon>
                  </v-btn>
                </template>
                <div style="word-break: break-word;" class="notification-recipients-tooltip">Edit the calamity email recipient list <br>{{item.NotificationRecipients}}</div>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" class="close-calamity-dialog-btn" icon v-on:click="closeCalamityConfirm(item.Id)">
                    <v-icon>remove</v-icon>
                  </v-btn>
                </template>
                <span>Close out this calamity</span>
              </v-tooltip>
              <!--<v-tooltip bottom v-if="item.CallsInstanceId">
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" class="close-calamity-dialog-btn" icon v-on:click="getCalamityStatus(item.Id, item.CallsInstanceId)">
                    <v-icon>perm_phone_msg</v-icon>
                  </v-btn>
                </template>
                <span>Get Calmity Calls Status</span>
              </v-tooltip>-->
            </v-row>
          </td>
        </tr>
      </template>
    </v-data-table>
    <carrier-request></carrier-request>
    <client-email></client-email>
    <edit-client-email></edit-client-email>
    <calamity-calls></calamity-calls>
    <calamity-calls-status></calamity-calls-status>
    <v-dialog v-model="closeDialog" persistent max-width="310">
      <v-card>
        <v-card-title class="headline">Close out this calamity?</v-card-title>
        <v-card-text>Closing out the calamity will terminate automated reports. </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" class="close-calamity-cancel-btn" text @click.native="closeDialog = false">Cancel</v-btn>
          <v-btn color="green darken-1" class="close-calamity-confirm-btn" text @click.native="closeCalamity()">Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="calamityCallsDialog" persistent max-width="800">
      <v-card>
        <v-card-title class="headline">Fetch Calamity Packages</v-card-title>
        <v-card-text style="padding: 0 25px 10px 25px !important;">
          <v-data-table :mobile-breakpoint="0" disable-pagination hide-default-footer show-select v-model="selected" item-key="Id" :items="calamityCallsNeeded" :headers="callSelectHeaders"/>
        </v-card-text>
        <v-card-actions style="padding: 0 25px 20px 25px;">
          <v-btn color="green darken-1" class="close-calamity-cancel-btn" text @click.native="calamityCallsDialog = false">Cancel</v-btn>
          <v-btn color="green darken-1" class="close-calamity-confirm-btn" :disabled="selected.length == 0" text @click.native="sendCalls()">Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
  </v-slide-y-transition>
  </v-container>
<!-- eslint-enable -->
</template>

<script>
import { mapGetters } from "vuex";
import CarrierRequest from "./CarrierRequestDialog";
import ClientEmail from "./ClientEmailDialog";
import EditClientEmail from "./EditClientEmailDialog";
import CalamityCalls from "./CalamityCallsDialog";
import CalamityCallsStatus from "./CalamityCallsStatusDialog";
import calamityModule, { CALAMITY_NAMESPACE } from "./store/calamityStore";

export default {
  name: "Calamities",
  components: {
    "carrier-request": CarrierRequest,
    "client-email": ClientEmail,
    "edit-client-email": EditClientEmail,
    "calamity-calls": CalamityCalls,
    "calamity-calls-status": CalamityCallsStatus
  },
  data() {
    return {
      callSelectHeaders: [
        {
          text: "Id",
          value: "Id",
          align: "left"
        },
        {
          text: "Date",
          value: "Date",
          align: "left"
        },
        {
          text: "Client",
          value: "Client",
          align: "left"
        },
        {
          text: "Location",
          value: "Location",
          align: "left"
        },
        {
          text: "Total",
          value: "PackageCount",
          align: "left",
          width: "40"
        }
      ],
      selected: [],
      calamityCallsDialog: false,
      closeDialog: false,
      fab: false,
      headers: [
        {
          text: "Id",
          value: "Id",
          align: "left"
        },
        {
          text: "Date",
          value: "Date",
          align: "left"
        },
        {
          text: "Title",
          value: "Title",
          align: "left"
        },
        {
          text: "Client",
          value: "Client",
          align: "left"
        },
        {
          text: "Location",
          value: "Location",
          align: "left"
        },
        {
          text: "Client Notification",
          value: "NotificationCallsSent",
          width: "10"
        },
        {
          text: "Carrier Req.",
          value: "CarrierRequestSent",
          width: "10"
        },
        {
          text: "Transit",
          value: "PackageCount",
          align: "left",
          width: "40"
        },
        {
          text: "Total",
          value: "PackageCount",
          align: "left",
          width: "40"
        },
        {
          text: "",
          align: "left",
          width: "40"
        }
      ],
      selectedCalamityId: null,
      TransitProperties: {
        Manifested: {
          key: "Manifested",
          class: "ManifestedState",
          name: "Manifest"
        },
        InTransit: {
          key: "InTransit",
          class: "InTransitState",
          name: "In Transit"
        },
        AtDestination: {
          key: "AtDestination",
          class: "AtDestinationState",
          name: "At Destination"
        },
        OutforDelivery: {
          key: "OutforDelivery",
          class: "OutForDeliveryState",
          name: "Out For Delivery"
        },
        Delivered: {
          key: "Delivered",
          class: "DeliveredState",
          name: "Delivered"
        }
      }
    };
  },
  computed: {
    ...mapGetters(CALAMITY_NAMESPACE, ["calamities", "loading"]),
    calamityCallsNeeded() {
      return this.calamities.filter(x => !x.NotificationCallsSent || true);
    }
  },
  created: /* istanbul ignore next */ function() {
    this.$registerVuexModule(CALAMITY_NAMESPACE, calamityModule);
    this.$isInRole([this.$roleDefs.ADMIN, this.$roleDefs.CALAMITY_ADMIN]).then(
      res => {
        if (res) {
          this.loadCalamities();
        } else this.$goHome();
      }
    );
  },
  methods: {
    openCalamityCallsDialog() {
      this.$isInRole([this.$roleDefs.ADMIN, this.$roleDefs.BETA_FEATURE]).then(
        res => {
          if (res) {
            this.selected = [];
            this.calamityCallsDialog = true;
          }
        }
      );
    },
    closeCalamity() {
      return this.$store
        .dispatch(
          `${CALAMITY_NAMESPACE}/CLOSE_CALAMITY`,
          this.selectedCalamityId
        )
        .then(res => {
          this.closeDialog = false;
          this.selectedCalamityId = null;
        });
    },
    closeCalamityConfirm(id) {
      this.closeDialog = true;
      this.selectedCalamityId = id;
    },
    editClientEmail(id, notificationRecipients) {
      this.$emit("editClientEmail", {
        calamityId: id,
        notificationRecipients: notificationRecipients
      });
    },
    loadCalamities() {
      return this.$store.dispatch(`${CALAMITY_NAMESPACE}/LOAD`);
    },
    sendCalls(id) {
      var packagesIdData = {
        CalamityIds: [],
        ClientIds: []
      };
      this.selected.forEach(x => {
        packagesIdData.CalamityIds.push(x.Id);
        if (!packagesIdData.ClientIds.includes(x.ClientId))
          packagesIdData.ClientIds.push(x.ClientId);
      });

      this.$isInRole([this.$roleDefs.ADMIN, this.$roleDefs.BETA_FEATURE]).then(
        res => {
          if (res) {
            this.$store
              .dispatch(
                `${CALAMITY_NAMESPACE}/getCalamitySummary`,
                packagesIdData
              )
              .then(() => {
                this.calamityCallsDialog = false;
                this.$emit("calamityCalls");
              });
          } else {
            this.calamityCallsDialog = false;
          }
        }
      );
    },
    sendClientEmail(id) {
      this.$emit("clientEmail", {
        calamityId: id
      });
    },
    sendRequest(id) {
      this.$emit("carrierRequest", {
        calamityId: id
      });
    },
    getCalamityStatus(id, instanceId) {
      this.$emit("calamityCallsStatus", {
        CalamityId: id,
        InstanceId: instanceId
      });
    }
  }
};
</script>
